import React, { useMemo } from 'react'
import { PropertyRenderer } from '@/components/changeRequests'
import { actionButtonsColumnProps, Column, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { useLocalization } from '@/hooks/localization'
import kebabCase from 'lodash/kebabCase'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'
import { PermissionSectionProvider } from '@/components/changeRequests/institutionPermissionProvider'
import { individualPermissionTypes } from '@/enums/individualPermissionTypes'
import { IndividualPermissionProvider } from '@/components/changeRequests/individualPermissionProvider'

const InstitutionChangeRequestHistory = React.memo(function InstitutionChangeRequestHistory ({ dataSource }) {
  return (
    <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.ChangeHistory}>
      <ChangeRequestHistory dataSource={dataSource} />
    </PermissionSectionProvider>
  )
})

const IndividualChangeRequestHistory = React.memo(function IndividualChangeRequestHistory ({ dataSource }) {
  return (
    <IndividualPermissionProvider individualPermission={individualPermissionTypes.enum.IndividualChangeHistory}>
      <ChangeRequestHistory dataSource={dataSource} individualPermission={individualPermissionTypes.enum.IndividualChangeHistory} />
    </IndividualPermissionProvider>
  )
})

const ChangeRequestHistory = React.memo(function ChangeRequestHistory (props) {
  const { dataSource } = props
  const { localize } = useLocalization()
  const isGranted = usePermissionChecker()
  const defaultSort = useMemo(() => ([{ field: 'lastModificationTime', dir: 'desc' }]), [])

  const canViewCHR = isGranted('CanViewChangeRequests')

  return (
    <PropertyRenderer name='changeRequestHistory' inputType='grid' dataSource={dataSource} readonly
      defaultSort={defaultSort}>
      <Column field='changeRequestId' title={localize('Tasks.ChangeRequest') + ' ' + localize('Common.Id')} filter='numeric' />
      <Column field='lastModificationTime' title={localize('Common.ChangeDate')} filter='date' filterCell={DateFilterCell} cell={DateCell} />
      <Column field='ticketName' title={localize('Tickets.TicketName')} />
      <Column field='ticketType' title={localize('Tickets.Type')} />
      <Column field='ticketDescription' title={localize('Common.Description')} />
      <Column field='ticketAuthor' title={localize('Common.Author')} filter='text' />
      {canViewCHR && <Column {...actionButtonsColumnProps([{ url: ci => `/${kebabCase(ci.changeItemScope)}/~${ci.changeItemId}`, icon: 'show' }], localize('Tasks.ChangeRequest'))} />}
      <Column {...actionButtonsColumnProps([{ url: ci => `/tickets/${ci.ticketId}`, icon: 'show' }], localize('Tickets.Title'))} />
    </PropertyRenderer>
  )
})

export { InstitutionChangeRequestHistory, IndividualChangeRequestHistory }



// WEBPACK FOOTER //
// ./src/components/demographics/changeRequestHistory.js